<template>
    <div>
        <v-form ref="form" v-model="valid" data-cy="forgot-password-form" @keyup.enter="forgotPassword">
            <v-text-field
                v-model="email"
                :placeholder="$t('email')"
                type="email"
                :rules="validationRules('email', [emailRule, requiredRule])"
                required
                density="compact"
                variant="outlined"
                data-cy="authorization-email-input"
            />
        </v-form>
        <v-btn
            :loading="isLoading"
            :disabled="isLoading || !valid"
            color="primary"
            class="mr-2"
            data-cy="forgot-password-button"
            @click="forgotPassword"
        >
            {{ $t('submit') }}
        </v-btn>
        <v-btn variant="outlined" color="primary" class="text-capitalize" @click="$emit('switch-login')">
            {{ $t('sign_in') }}?
        </v-btn>
    </div>
</template>

<script lang="ts">
    import {Component, mixins} from 'vue-facing-decorator'
    import {fullUrl} from '~src/utils/host-adapter'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'

    @Component
    export class ForgotPasswordForm extends mixins(FormValidationRulesMixin) {
        email = null
        valid = false

        mounted() {
            this.$refs.form.resetValidation()
        }

        async forgotPassword() {
            if (!this.valid) return

            try {
                //TODO Get clientName from separate param when dynamic titles for different pages was implemented
                const rq = {
                    email: this.email,
                    redirectUrl: fullUrl('/restore-password'),
                    clientName: document.title,
                }
                await this.restorePassword(rq)
                this.$toast.success(this.$t('messages.success.forgot_password'))
                this.$emit('forgot-password-success')
            } catch (e) {
                this.$toast.warning(e.msg || e.errors[0].message)
            }
        }

        async restorePassword(rq) {
            return await this.$api.restorePassword.post(rq)
        }

        get isLoading() {
            return runtimeStore.authActive
        }

        get person() {
            return authStore.person
        }
    }

    export default ForgotPasswordForm
</script>
